<template>
  <div v-if="loaded">
     <div class="md-layout-item md-size-100 page">
            <div class="section_body">
                <div class="section_title">
                <h2>Industry Financial Insights</h2>
                <span class="date">{{ moment(new Date()).format('MMM Do YYYY') }}</span>
                </div>

                 <div class="tble-box">
                    <div class="tbl-title">
                    <h4 v-if="releaseDate"> Industry Financial Insights <span class="info">{{months[releaseDate.getMonth()] + " " +releaseDate.getFullYear() }}</span></h4>
                    </div>  
                    <div class="inner-tbl">
                        <div v-if="spendInfo" class="md-layout-item md-medium-size-100 md-size-100 p-0">
                            <md-table v-model="spendInfo"  
                               table-header-color="blue"
                                class="dark_blue"
                                style="flex: 1;">
                            <md-table-row slot="md-table-row" slot-scope="{ item }">
                                <md-table-cell
                                md-label="Financial Metrics (Peer industry and sales class average % basis)">
                                {{ item.name }}
                                </md-table-cell>

                                <md-table-cell md-label="Dollar">{{ item.dollar }}</md-table-cell>
                                <md-table-cell md-label="Percentage">{{ item.percentage }}</md-table-cell>
                            </md-table-row>
                            </md-table>
                            <md-table v-if="benchmarksInfo" v-model="benchmarksInfo"  table-header-color="blue"
                                class="dark_blue"
                                style="flex: 1;">
                            <md-table-row slot="md-table-row" slot-scope="{ item }">
                                <md-table-cell md-label="Benchmark">{{ item.name }}</md-table-cell>
                                <md-table-cell md-label="Ratio">{{ item.value }}</md-table-cell>
                            </md-table-row>
                            </md-table>
                        </div>
                    </div> 
                 </div>
            </div>    
            <p class="common_footer ">Copyright © 2022 Bizminer. All Rights Reserved.</p>
    </div>

     <div class="md-layout-item md-size-100 page">
            <div class="section_body">

                 <div class="tble-box">
                    <div class="tbl-title" v-if="releaseDate">
                    <h4> Company Value Insights <span class="info">{{months[releaseDate.getMonth()] + " " +releaseDate.getFullYear() }}</span></h4>
                    </div>  
                    <div class="inner-tbl">
                        <md-table
                        v-model="valueInsights"
                        table-header-color="blue"
                        class="dark_blue"
                        style="flex: 1;"
                        >
                        <md-table-row
                        slot="md-table-row"
                        slot-scope="{ item }"
                        >
                        <md-table-cell md-label="Intervals">{{ item.name }}</md-table-cell>
                        <md-table-cell md-label="Earnings">{{ item.earnings }}</md-table-cell>
                        <md-table-cell md-label="Sales">{{ item.sales }}</md-table-cell>
                        </md-table-row>
                        </md-table>
                    </div> 
                 </div>
            </div>    
            <p class="common_footer black-color">Copyright © 2022 Bizminer. All Rights Reserved.</p>
    </div>

     <div class="md-layout-item md-size-100 page">
            <div class="section_body">

                 <div class="tble-box">
                    <div class="tbl-title" v-if="releaseDate">
                    <h4>  Industry Market Insights  <span class="info">{{months[releaseDate.getMonth()] + " " +releaseDate.getFullYear() }}</span></h4>
                    </div>  
                    <div class="inner-tbl">
                        <md-table
                        v-model="penetration"
                        table-header-color="blue"
                        class="dark_blue"
                        style="flex: 1;"
                        >
                        <md-table-row
                        slot="md-table-row"
                        slot-scope="{ item }"
                        >
                        <md-table-cell md-label="Market Penetration">{{ item.name }}</md-table-cell>
                        <md-table-cell md-label="Dollars">{{ item.dollars }}</md-table-cell>
                        </md-table-row>
                        </md-table>
                    </div> 


                     <div class="inner-tbl">
                        <md-table
                        v-model="main"
                        table-header-color="blue"
                        class="dark_blue"
                        style="flex: 1;"
                        >
                            <md-table-row
                            slot="md-table-row"
                            slot-scope="{ item }"
                            >
                            <md-table-cell md-label="Industry Market Overview">{{ item.name }}</md-table-cell>
                            <md-table-cell md-label="Value">{{ item.dollars }}</md-table-cell>
                            </md-table-row>
                        </md-table>
                    </div> 


                     <div class="inner-tbl">
                        <md-table
                        v-model="income"
                        table-header-color="blue"
                        class="dark_blue"
                        style="flex: 1;"
                        >
                            <md-table-row
                            slot="md-table-row"
                            slot-scope="{ item }"
                            >
                            <md-table-cell md-label="Market Area Population and Income">{{ item.name }}</md-table-cell>
                            <md-table-cell md-label="Value">{{ item.dollars }}</md-table-cell>
                            </md-table-row>
                        </md-table>
                    </div> 


                 </div>
            </div>    
            <p class="common_footer footer-formatting">Copyright © 2022 Bizminer. All Rights Reserved.</p>
    </div>
  </div>
</template>

<script>
import { NavTabsCard, ChartCard } from '@/components';
import { mapState } from 'vuex';
import formatData from '@/mixins/format-data';
import moment from 'moment'
export default {
  components: {
   // ChartCard,
  },
  mixins: [formatData],
  data() {
    return {
      months: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December",
      ],   
      view: ' Industry Financial Insights',
      loaded:false,
      moment: moment,
      inssights:'',
    };
  },
  computed: {
     ...mapState({
      user: (state) => state.user.user,
    }),
    releaseDate() {
      return this.$store.getters.releaseDate;
    },

    ifInfo() {
      return this.$store.getters.profileInfo;
    },
    spendInfo() {
      let spendInfo = this.ifInfo["IF"].spend;
      let result = Object.keys(spendInfo).map((key) => {
        return {
          name: key,
          dollar: spendInfo[key].dollar,
          percentage: spendInfo[key].percentage,
        };
      });
      return result;
    },
    benchmarksInfo() {
      let benchmarksInfo = this.ifInfo["IF"].benchmarks;
      let result = Object.keys(benchmarksInfo).map((key) => {
        return {
          name: key,
          value: benchmarksInfo[key],
        };
      });
      return result;
    },
    valueInsights() {
      let valueInfo = this.$store.getters.profileInfo.multiples.data;

      let result = Object.keys(valueInfo).map((key) => {
        return {
          name: key,
          earnings: valueInfo[key].earnings,
          sales: valueInfo[key].sales,
        };
      });
      return result;
    },

    profileMRInfo() {
      return this.$store.getters.profileInfo.MR;
    },

    penetration() {
      let penetrationInfo = this.profileMRInfo.penetration;

      let result = Object.keys(penetrationInfo).map((key) => {
        return {
          name: key,
          dollars: penetrationInfo[key],
        };
      });

      return result;
    },
    main() {
      let mainInfo = this.profileMRInfo.main;

      let result = Object.keys(mainInfo).map((key) => {
        return {
          name: key,
          dollars: mainInfo[key],
        };
      });

      return result;
    },
    income() {
      let incomeInfo = this.profileMRInfo.income;

      let result = Object.keys(incomeInfo).map((key) => {
        return {
          name: key,
          dollars: incomeInfo[key],
        };
      });

      return result;
    },
   
  },
  mounted() {
       this.inssights=1;
  },
  watch: {
      inssights(newVal, oldVal) {
      this.init();
    }
  },
  methods: {
    init(){
          let section = this.$route.query.section;
          if (!section) {
          section = 'cash-flow-solvency';
          }
       
          this.loaded=true;
    },

     numberWithPoints(x) {
      if (typeof x === 'number') {
        return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
      } else if(x === null){
        return x;
      }else
      {
        return x.replace(/,/g, '.');
      }
    },
    
   
  },
};

</script>
